var render, staticRenderFns
import script from "./contract_closure.vue?vue&type=script&lang=js"
export * from "./contract_closure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96e44108')) {
      api.createRecord('96e44108', component.options)
    } else {
      api.reload('96e44108', component.options)
    }
    
  }
}
component.options.__file = "src/views/dms/views/contract/form/contract_closure.vue"
export default component.exports